export default "__VITE_ASSET__BfQRNSNh__"